module.exports = __webpack_public_path__ + "static/media/hand-holding-seedling.93ea0d6e.svg";